import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-user-redirect',
  template: ``,
  standalone: false,
})
export class UserRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      this.router.navigate([data['redirect']]); // Navigate based on resolver result
    });
  }
}
